import { animated, useSpring } from "react-spring";
import { springConfigs } from "../../../constants/springConfigs";
import { useWindowSize } from "../../../hooks/useWindowSize";

export const CreatingA = () => {
  const { marginTop } = useSpring({
    from: { marginTop: "10vh" },
    to: { marginTop: "0px" },
    config: springConfigs.textAppear,
  });

  const { h, horizontal } = useWindowSize();

  return (
    <div
      {...{
        style: {
          fontWeight: 700,
          letterSpacing: "-0.04em",
          fontSize: horizontal ? h(10.5) : h(7),
          lineHeight: horizontal ? h(9.5) : h(6),
        },
      }}
    >
      <div
        style={{
          overflowY: "hidden",
          fontWeight: "700",
          letterSpacing: "-0.05em",
          height: horizontal ? h(12.5) : h(11),
        }}
      >
        <animated.div
          {...{
            style: {
              marginTop: marginTop,
              marginLeft: "-1px",
            },
          }}
        >
          Creating a
        </animated.div>
      </div>
    </div>
  );
};
export const BioComputer = () => {
  const { h, horizontal } = useWindowSize();

  const { marginTop2 } = useSpring({
    from: { marginTop2: "10vh" },
    to: { marginTop2: "0px" },
    config: springConfigs.textAppear,
    delay: 400,
  });

  return (
    <div
      {...{
        style: {
          fontWeight: 700,
          letterSpacing: "-0.04em",
          fontSize: horizontal ? h(10.5) : h(7),
          lineHeight: horizontal ? h(9.5) : h(6),
        },
      }}
    >
      <div
        style={{
          overflowY: "hidden",
          marginTop: "-1rem",
          height: horizontal ? h(12.5) : h(11),
        }}
      >
        <animated.div
          {...{
            style: {
              marginTop: marginTop2,
              marginLeft: "-2px",
            },
          }}
        >
          Biocomputer
        </animated.div>
      </div>
    </div>
  );
};
